import {
  Flex,
  NumberInput,
  PasswordInput,
  Text,
  TextInput,
} from "@mantine/core";
import { Controller } from "react-hook-form";

const inputWidth = 220;

const SmtpSection = ({ control }) => {
  return (
    <Flex direction="column" gap="sm">
      <Text size="sm" fw={600}>
        SMTP configuration
      </Text>
      <Flex wrap="wrap" gap="md">
        <Controller
          name="smtp.mailFrom"
          control={control}
          render={({ field }) => (
            <TextInput
              {...field}
              label="Mail From"
              placeholder="user@domain.com"
              w={inputWidth}
            />
          )}
        />
        <Controller
          name="smtp.server"
          control={control}
          render={({ field }) => (
            <TextInput
              {...field}
              label="SMTP Server"
              placeholder="smtp.mailprovider.com"
              w={inputWidth}
            />
          )}
        />
        <Controller
          name="smtp.port"
          control={control}
          render={({ field }) => (
            <NumberInput
              {...field}
              label="SMTP Port"
              placeholder="587"
              w={120}
              hideControls
              onChange={(val) => field.onChange(val === "" ? null : val)}
            />
          )}
        />
        <Controller
          name="smtp.username"
          control={control}
          render={({ field }) => (
            <TextInput
              {...field}
              label="Username"
              placeholder="Username"
              w={inputWidth}
            />
          )}
        />
        <Controller
          name="smtp.password"
          control={control}
          render={({ field }) => (
            <PasswordInput
              {...field}
              value={field.value ?? ""}
              label="Password"
              placeholder="••••••••"
              w={inputWidth}
            />
          )}
        />
      </Flex>
    </Flex>
  );
};

export default SmtpSection;
